import React, { useState, useEffect, useCallback } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { useAdminStyles, num, date } from "./styles";

// Franquia consumida no ciclo, com ajuste manual.
//
// O caso de uso real: o cliente queimou execuções por uma falha nossa. Sem isto
// a única saída seria subir o plano dele — que cobra a mais e suja o
// faturamento. O ajuste mexe no CONTADOR do ciclo; o extrato tarifado
// (UsageEvents) não é tocado, então o dinheiro já registrado continua verdadeiro.
const UserCounters = ({ userId }) => {
  const classes = useAdminStyles();
  const [d, setD] = useState(null);
  const [editando, setEditando] = useState(null);
  const [valor, setValor] = useState("");
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/admin/users/${userId}/counters`);
      setD(data);
    } catch (err) {
      toastError(err);
    }
  }, [userId]);

  useEffect(() => { load(); }, [load]);

  const salvar = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/users/${userId}/counters`, {
        counter: editando.counter,
        quantity: Number(String(valor).replace(",", ".")),
        reason: motivo,
      });
      toast.success(`${editando.label}: ${num(data.de)} → ${num(data.para)}`);
      setEditando(null);
      setMotivo("");
      load();
    } catch (err) {
      toastError(err);
    } finally {
      setBusy(false);
    }
  };

  if (!d) return null;

  return (
    <div className={classes.card}>
      <div className={classes.cardTitle}>Franquias do ciclo</div>
      <div className={classes.cardSub}>
        Ciclo de {date(d.cycle.start)} a {date(d.cycle.end)}
        {d.plano ? ` · plano ${d.plano.name}` : ""}. Ajustar altera o consumido, não o extrato tarifado.
      </div>

      {d.franquias.map((f, i) => {
        const pct = f.limite ? Math.min(100, Math.round((f.usado / f.limite) * 100)) : 0;
        const estourou = f.limite != null && f.usado > f.limite;
        return (
          <div key={f.counter} className={`${classes.row} ${i === 0 ? classes.rowFirst : ""}`}>
            <div className={classes.grow}>
              <div className={classes.strong}>{f.label}</div>
              {f.limite != null && (
                <div className={classes.bar}>
                  <div className={classes.barFill} style={{ width: `${pct}%`, background: estourou ? "#B12A2A" : undefined }} />
                </div>
              )}
            </div>
            <div className={classes.num} style={{ width: 150, textAlign: "right" }}>
              {num(Math.round(f.usado * 100) / 100)}
              <span className={classes.muted}> / {f.limite == null ? "ilimitado" : num(f.limite)} {f.unit}</span>
            </div>
            <Button size="small" onClick={() => { setEditando(f); setValor(String(f.usado)); setMotivo(""); }}>
              Ajustar
            </Button>
          </div>
        );
      })}

      {editando && (
        <div className={classes.card} style={{ marginTop: 12, marginBottom: 0, background: "#FAFBFC" }}>
          <div className={classes.cardTitle}>Ajustar “{editando.label}”</div>
          <div className={classes.cardSub}>
            Consumido hoje: {num(editando.usado)} {editando.unit}. O novo valor passa a valer para o restante do ciclo.
          </div>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <TextField label="Novo valor" size="small" variant="outlined" style={{ width: 150 }}
              value={valor} onChange={e => setValor(e.target.value)} />
            <TextField label="Motivo (fica na auditoria)" size="small" variant="outlined" style={{ flex: 1 }}
              value={motivo} onChange={e => setMotivo(e.target.value)} />
            <Button onClick={() => setEditando(null)} disabled={busy}>Cancelar</Button>
            <Button variant="contained" color="primary" onClick={salvar} disabled={busy || !motivo.trim()}>
              {busy ? "Salvando…" : "Salvar"}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserCounters;
